import { FC, PropsWithChildren } from 'react';

import { x } from '@ui-furniture/style';

export const InputPrependContainer: FC<PropsWithChildren> = ({ children }) => (
  <x.div
    display='flex'
    alignItems='center'
    justifyContent='center'
    h='input'
    minWidth='input'
    px='md'
  >
    {children}
  </x.div>
);
